import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './index';

const store = configureStore({ reducer: rootReducer });

export type AppDispatchType = typeof store.dispatch;
export type StoreType = typeof store

export default store;
